export const CREATE_RESERVE_CUSTOM_FIELD = 'CREATE_RESERVE_CUSTOM_FIELD'
export const UPDATE_RESERVE_CUSTOM_FIELD = 'UPDATE_RESERVE_CUSTOM_FIELD'
export const DELETE_RESERVE_CUSTOM_FIELD = 'DELETE_RESERVE_CUSTOM_FIELD'